import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'mismatch-disclaimer',
    templateUrl: './mismatch-disclaimer.component.html',
    styleUrls: ['./mismatch-disclaimer.component.scss'],
})
export class MismatchDisclaimerComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
